<div class="modal-header container-md" id="modal-header">
  <div class="col-4"></div>
  <div class="col-4">
    <img
      id="modal-memorabid-logo"
      src="/assets/img/memorabid-logo-white.svg"
      alt="MEMORABID"
    />
  </div>
  <div class="col-3"></div>
  <div class="col-1">
    <button
      id="closeButton"
      type="button"
      class="close"
      aria-label="Close"
      (click)="activeModal.dismiss()"
    >
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
</div>
<div class="modal-body">
  @if (currentPage === 'welcome') {
  <app-welcome (goToLoginEvent)="goToLogin()" (goToRegisterEvent)="goToRegister()">
  </app-welcome>
  } @else if (currentPage === 'login') {
  <app-sign-in [nextPageRoute]="nextPageRoute"
      (changePage)="handleChangePage($event)"
      (closeModal)="activeModal.dismiss()"
    ></app-sign-in>
  } @else if (currentPage === 'register') {
  <app-sign-up [nextPageRoute]="nextPageRoute" [idEvent]="idEvent"
      (changePage)="handleChangePage($event)"
    ></app-sign-up>
  } @else if (currentPage === 'reset') {
  <app-request-reset-password [prefillEmail]="resetEmailPrefill" [redirectPath]="nextPageRoute"></app-request-reset-password>
  } @else if (currentPage === 'magic') {
  <div class="container-md py-3 text-center">
    <h5 class="mb-0">{{ 'IDS_CHECK_EMAIL' | translate }}</h5>
  </div>
  } @else if (currentPage === 'magicRequest') {
  <app-magic-link-request [redirectPath]="nextPageRoute" [prefillEmail]="resetEmailPrefill" (changePage)="handleChangePage($event)"></app-magic-link-request>
  }
</div>
